exports = module.exports = require("../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.nav-link {\n    cursor: pointer;\n}\n.sidebar .nav .nav-item.scroll-to-top-btn {\n    position: fixed;\n    bottom: 0;\n}\n.fade-enter-active, .fade-leave-active {\n    transition: opacity 1s\n}\n.fade-enter, .fade-leave-to {\n    opacity: 0\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-351b5566","scoped":false,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sidebar.vue
// module id = 789
// module chunks = 1